function token() {
  return localStorage.getItem("token") || sessionStorage.getItem("token") || "";
}
function authHeaders(json) {
  const h = {};
  const t = token();
  if (t) h.Authorization = `Bearer ${t}`;
  if (json) h["Content-Type"] = "application/json";
  return h;
}
const enc = encodeURIComponent;
export async function listMaster({ q, hsk } = {}) {
  const p = new URLSearchParams();
  if (q) p.set("q", q);
  if (hsk) p.set("hsk", hsk);
  const qs = p.toString();
  const r = await fetch(`/api/onto/master-hs${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(false),
  });
  if (!r.ok) return { items: [] };
  return r.json();
}
export async function summaryMaster() {
  const r = await fetch("/api/onto/master-hs/summary", {
    headers: authHeaders(false),
  });
  if (!r.ok) return { items: [], total: 0, error: true };
  return r.json();
}
export async function similarMaster(keyword, limit = 5) {
  const r = await fetch(
    `/api/onto/master-hs/similar?keyword=${enc(keyword)}&limit=${limit}`,
    { headers: authHeaders(false) },
  );
  if (!r.ok) return { items: [], error: true };
  return r.json();
}
export async function upsertMaster({
  keyword,
  hsk,
  productName,
  composition,
  supplier,
}) {
  const r = await fetch("/api/onto/master-hs", {
    method: "PUT",
    headers: authHeaders(true),
    body: JSON.stringify({ keyword, hsk, productName, composition, supplier }),
  });
  return r.ok;
}
export async function removeMaster(keyword) {
  const r = await fetch("/api/onto/master-hs", {
    method: "DELETE",
    headers: authHeaders(true),
    body: JSON.stringify({ keyword }),
  });
  return r.ok;
}
